{
    "TeamsAuth_UserIntro": "Olá **{}**,",
    "TeamsAuth_UserIntro_2": "O Akixi for MS Teams está a solicitar acesso ao seu Microsoft Entra Tenant",
    "TeamsAuth_AdminConsent": "Autorização do administrador da concessão",
    "TeamsAuth_Authorise": "Autorizar",
    "TeamsAuth_ConsentedMessage": "Autorização de administração concedida, clique em Autorizar para continuar",
    "TeamsAuth_AuthorisedMessage": "Autorização concedida",
    "TeamsAuth_Decline": "Declínio",
    "TeamsAuth_Error_Unknown": "Ocorreu um erro não reconhecido. Tente novamente. Se o problema persistir, contacte o administrador do sistema.",
    "NAME": "TeamsAuth",
    "TeamsAuth_Authoriser_Select_Title": "Quais utilizadores gostaria de sincronizar do seu Tenant do Microsoft Entra?",
    "TeamsAuth_Authoriser_Select_Options_Tenant": "Todos os utilizadores aplicáveis do Tenant",
    "TeamsAuth_Authoriser_Select_Options_SecurityGroups": "Apenas grupos de segurança selecionados",
    "TeamsAuth_SecurityGroups_Loader_Title_1": "Obtendo grupos de segurança",
    "TeamsAuth_SecurityGroups_Loader_Title_2": "Isso não deve demorar muito, por favor, tenha paciência...",
    "TeamsAuth_SecurityGroups_Title": "Por favor, selecione os seus grupos de segurança.",
    "TeamsAuth_SecurityGroups_SecurityGroup_NothingToSee": "Nenhum grupo de segurança foi encontrado...",
    "TeamsAuth_SecurityGroups_SecurityGroup": "[ID: {}]",
    "TeamsAuth_SecurityGroups_Note": "Nota: os grupos de segurança podem ser atualizados posteriormente.",
    "TeamsAuth_SecurityGroups_SyncAndClose": "Sincronizar e fechar",
    "TeamsAuth_SecurityGroups_NoSecurityGroups": "Sincronizar todo o Tenant"
}